import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { BehaviorService } from '@_services/Behavior.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-business',
  templateUrl: './business.component.html',
  styleUrls: ['./business.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BusinessComponent implements OnInit, OnDestroy {
  @Input() SettingForm: FormGroup;
  @Input() errorWarningData: any;
  @Output() myOutput: EventEmitter<string> = new EventEmitter();
  officeFormateArray: any = [];
  unitHRArray: any = [];
  getDropDownValue: any = [];
  accessTierPermission: any = JSON.parse(localStorage.getItem('set_tier_permission'));
  currentUser: any = JSON.parse(localStorage.getItem('currentUser'));
  userData: any = {};
  class: boolean;
  rateList: any[] = [];
  sub: Subscription;
  sub1: Subscription;
  sub2: Subscription;
  appPermissions: any = JSON.parse(localStorage.getItem('app_permissions'));
  public isspiner: boolean = false;
  public isspinerTE: boolean = false;
  public isspinerRates: boolean = false;
  private _unsubscribeAll$: Subject<void> = new Subject();
  CurrenctSymbol = '';
  constructor(
    private _mainAPiServiceService: MainAPiServiceService,
    private behaviorService: BehaviorService,
    private toastr: ToastrService,
    private cd: ChangeDetectorRef,
  ) {
    localStorage.setItem('istrackid', 'SystemSettingBusinessComponent');
  }
  ngOnInit() {
    const storedSymbol = localStorage.getItem('set_active_CURRENCYSYMBOL');
    this.CurrenctSymbol =
      storedSymbol && storedSymbol !== 'undefined' ? JSON.parse(storedSymbol) : '$';
    let Rates_lookups = localStorage.getItem('Rates_lookups');
    if (Rates_lookups && Rates_lookups != 'null') {
      this.rateList = JSON.parse(Rates_lookups);
    } else {
      this.sub = this._mainAPiServiceService
        .getSetData({ Action: 'getdata', Filters: { LookupType: 'Rates' } }, 'lookup')
        .subscribe({
          next: (responses: any) => {
            if (responses.CODE === 200 && responses.STATUS === 'success') {
              localStorage.setItem('Rates_lookups', JSON.stringify(responses.DATA.LOOKUPS));
              this.rateList = responses.DATA.LOOKUPS;
              this.cd.markForCheck();
            }
          },
        });
    }
    this.sub1 = this.behaviorService.permissionCheckforHeight$.subscribe((data: any) => {
      this.class = data;
      this.cd.markForCheck();
    });
    // this.sub2 = this._mainAPiServiceService.getSetData({ EXCLUDESYSTEMACCOUNTS: true, EXCLUDEINVOICETEMPLATESETTINGS: true }, 'GetSystem').subscribe(response => {
    //     if (response.CODE == 200 && response.STATUS == "success") {
    //         this.getDropDownValue = response.DATA.LISTS;
    //         this.behaviorService.loadingSystemSetting('business');
    //     }
    // }, error => {
    //     this.toastr.error(error);
    // })

    this.loadData();
  }

  /**
   * load the data of business setup
   */
  loadData() {
    // this.isLoadingResults = true;
    this._mainAPiServiceService
      .getSetData({ Action: 'GetData', Filters: { GroupName: 'BusinessSetup' } }, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && response.STATUS == 'success') {
            // this.isLoadingResults = false;
            this.getDropDownValue = response.DATA.LISTS;
            this.behaviorService.loadingSystemSetting('business');
            let name = JSON.parse(localStorage.getItem('currentUser'));
            name.UserName = response.DATA.RECORDS.BARRISTERSNAME;
            let businessData = response.DATA.RECORDS;
            this.SettingForm.controls['GSTTYPE'].setValue(businessData.GSTTYPE.toString());
            // this.SettingForm.controls['ALLOWMOBILEACCESS'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.ALLOWMOBILEACCESS);
            // this.SettingForm.controls['DONTALLOWTRUSTOVERDRAWS'].setValue(data.DATA.SYSTEM.BUSINESSGROUP.DONTALLOWTRUSTOVERDRAWS);
            if (this.currentUser.PRODUCTTYPE == 'Barrister') {
              this.SettingForm.controls['HOURLYBASERATE'].setValue(businessData.HOURLYBASERATE);
              this.SettingForm.controls['DAILYBASERATE'].setValue(businessData.DAILYBASERATE);
              this.SettingForm.controls['HOURLYBASERATE2'].setValue(businessData.HOURLYBASERATE2);
              this.SettingForm.controls['DAILYBASERATE2'].setValue(businessData.DAILYBASERATE2);
              this.SettingForm.controls['HOURLYBASERATE3'].setValue(businessData.HOURLYBASERATE3);
              this.SettingForm.controls['DAILYBASERATE3'].setValue(businessData.DAILYBASERATE3);
              this.SettingForm.controls['HOURLYBASERATE4'].setValue(businessData.HOURLYBASERATE4);
              this.SettingForm.controls['DAILYBASERATE4'].setValue(businessData.DAILYBASERATE4);
              this.SettingForm.controls['HOURLYBASERATE5'].setValue(businessData.HOURLYBASERATE5);
              this.SettingForm.controls['DAILYBASERATE5'].setValue(businessData.DAILYBASERATE5);
              this.SettingForm.controls['HOURLYBASERATE6'].setValue(businessData.HOURLYBASERATE6);
              this.SettingForm.controls['DAILYBASERATE6'].setValue(businessData.DAILYBASERATE6);
              this.SettingForm.controls['CLERKRATE'].setValue(businessData.CLERKRATE);
            }
            this.SettingForm.controls['RATEDESCRIPTION1'].setValue(businessData.RATEDESCRIPTION1);
            this.SettingForm.controls['RATEDESCRIPTION2'].setValue(businessData.RATEDESCRIPTION2);
            this.SettingForm.controls['RATEDESCRIPTION3'].setValue(businessData.RATEDESCRIPTION3);
            this.SettingForm.controls['RATEDESCRIPTION4'].setValue(businessData.RATEDESCRIPTION4);
            this.SettingForm.controls['RATEDESCRIPTION5'].setValue(businessData.RATEDESCRIPTION5);
            this.SettingForm.controls['RATEDESCRIPTION6'].setValue(businessData.RATEDESCRIPTION6);

            this.SettingForm.controls['MATTERDELIVERABLEGUID'].setValue(businessData.DELIVERABLES);

            // this.SettingForm.controls['DELIVERABLES'].setValue(businessData.DELIVERABLES);
            this.SettingForm.controls['UNITSPERHOUR'].setValue(businessData.UNITSPERHOUR);
            this.SettingForm.controls['DUEDATEOFFSET'].setValue(businessData.DUEDATEOFFSET);
            this.SettingForm.controls['OFFICECHEQUEFORMAT'].setValue(
              businessData.OFFICECHEQUEFORMAT,
            );
            this.SettingForm.controls['VENDORISLIABLEFORSETTLEMENTDATE'].setValue(
              businessData.VENDORISLIABLEFORSETTLEMENTDATE,
            );
            // this.SettingForm.controls['USESINGLELINEEXPENSE'].setValue(businessData.USESINGLELINEEXPENSE);
            this.SettingForm.controls['RATEOVERRIDESEQUENCE'].setValue(
              businessData.RATEOVERRIDESEQUENCE,
            );
            this.SettingForm.controls['DEFAULTTRUSTRECEIPTTYPE'].setValue(
              businessData.DEFAULTTRUSTRECEIPTTYPE,
            );
            this.SettingForm.controls['DEFAULTTRUSTWITHDRAWALTYPE'].setValue(
              businessData.DEFAULTTRUSTWITHDRAWALTYPE,
            );
            this.SettingForm.controls['EFTTRUSTACCOUNTNAME'].setValue(
              businessData.EFTTRUSTACCOUNTNAME,
            );
            this.SettingForm.controls['EFTTRUSTACCOUNTNUMBER'].setValue(
              businessData.EFTTRUSTACCOUNTNUMBER,
            );
            this.SettingForm.controls['EFTTRUSTBSB'].setValue(businessData.EFTTRUSTBSB);

            this.SettingForm.controls['TRUSTACCACCOUNTNAME'].setValue(
              businessData.TRUSTACCACCOUNTNAME,
            );
            this.SettingForm.controls['TRUSTACCBSB'].setValue(businessData.TRUSTACCBSB);
            this.SettingForm.controls['TRUSTACCACCOUNTNUMBER'].setValue(
              businessData.TRUSTACCACCOUNTNUMBER,
            );

            this.SettingForm.controls['TRUSTFIRSTWITHDRAWALCODE'].setValue(
              businessData.TRUSTFIRSTWITHDRAWALCODE,
            );
            this.SettingForm.controls['TRUSTFIRSTWITHDRAWALEFTID'].setValue(
              businessData.TRUSTFIRSTWITHDRAWALEFTID,
            );
            this.SettingForm.controls['TRUSTFIRSTTRANSFERCODE'].setValue(
              businessData.TRUSTFIRSTTRANSFERCODE,
            );
            this.SettingForm.controls['TRUSTFIRSTRECEIPTCODE'].setValue(
              businessData.TRUSTFIRSTRECEIPTCODE,
            );

            this.SettingForm.controls['TRUSTCHEQUEFORMAT'].setValue(businessData.TRUSTCHEQUEFORMAT);
            this.SettingForm.controls['TRUSTRECEIPTCOPIES'].setValue(
              businessData.TRUSTRECEIPTCOPIES.toString(),
            );
            this.SettingForm.controls['TRUSTSTATE'].setValue(businessData.TRUSTSTATE);
            this.SettingForm.controls['FIRSTTRUSTMONTH'].setValue(businessData.FIRSTTRUSTMONTH);

            this.SettingForm.controls['DEFAULTEXPENSETYPE'].setValue(
              businessData.DEFAULTEXPENSETYPE,
            );
            this.SettingForm.controls['DEFAULTPAIDTYPE'].setValue(businessData.DEFAULTPAIDTYPE);
            this.SettingForm.controls['DEFAULTINCOMETYPE'].setValue(businessData.DEFAULTINCOMETYPE);
            this.SettingForm.controls['SHORTNAMESTRATEGY'].setValue(businessData.SHORTNAMESTRATEGY);
            this.SettingForm.controls['REQUIRECOSTAGREEMENT'].setValue(
              businessData.REQUIRECOSTAGREEMENT,
            );
            this.SettingForm.controls['REQUIREMATTEROWNER'].setValue(
              businessData.REQUIREMATTEROWNER,
            );
            this.SettingForm.controls['REQUIREFEEEARNER'].setValue(businessData.REQUIREFEEEARNER);
            this.SettingForm.controls['DEFAULTMATTERCLASS'].setValue(
              businessData.DEFAULTMATTERCLASS,
            );
            this.SettingForm.controls['REQUIREMATTERTYPE'].setValue(businessData.REQUIREMATTERTYPE);
            this.SettingForm.controls['REQUIRECLIENTSOURCE'].setValue(
              businessData.REQUIRECLIENTSOURCE,
            );
            this.SettingForm.controls['REQUIREFIELDOFLAW'].setValue(businessData.REQUIREFIELDOFLAW);
            this.SettingForm.controls['REQUIREEXPENSEPAYEE'].setValue(
              businessData.REQUIREEXPENSEPAYEE,
            );
            this.SettingForm.controls['SUNDRYFEEEARNER'].setValue(businessData.SUNDRYFEEEARNER);

            this.SettingForm.controls['SHOWCONFLICTCHECKFORNEWMATTER'].setValue(
              businessData.SHOWCONFLICTCHECKFORNEWMATTER,
            );
            this.SettingForm.controls['CHARGEDISBGSTONGSTFREEMATTERS'].setValue(
              businessData.CHARGEDISBGSTONGSTFREEMATTERS,
            );

            this.SettingForm.controls['ALLOWESTIMATERANGE'].setValue(
              businessData.ALLOWESTIMATERANGE,
            );
            this.SettingForm.controls['USEHIGHESTIMATEFORWARNING'].setValue(
              businessData.USEHIGHESTIMATEFORWARNING,
            );
            this.SettingForm.controls['ESTIMATEWARNINGPERCENT'].setValue(
              businessData.ESTIMATEWARNINGPERCENT,
            );
            this.SettingForm.controls['ESTIMATENEXTTHRESHOLD'].setValue(
              businessData.ESTIMATENEXTTHRESHOLD,
            );
            this.SettingForm.controls['ESTIMATENEXTWARNINGPERCENT'].setValue(
              businessData.ESTIMATENEXTWARNINGPERCENT,
            );

            this.SettingForm.controls['COUNTRY'].setValue(businessData.COUNTRY);
            this.SettingForm.controls['CURRENCYSYMBOL'].setValue(businessData.CURRENCYSYMBOL);
            this.SettingForm.controls['TIMEZONE'].setValue(businessData.TIMEZONE);
            this.SettingForm.controls['TAXRATE'].setValue(businessData.TAXRATE);
            this.SettingForm.controls['TAXTYPE'].setValue(businessData.TAXTYPE);
            this.SettingForm.controls['PRACACCACCOUNTNAME'].setValue(
              businessData.PRACACCACCOUNTNAME,
            );
            this.SettingForm.controls['PRACACCBSB'].setValue(businessData.PRACACCBSB);
            this.SettingForm.controls['PRACACCACCOUNTNUMBER'].setValue(
              businessData.PRACACCACCOUNTNUMBER,
            );
            this.SettingForm.controls['SWIFTID'].setValue(businessData.SWIFTID);
            if (businessData.NEWMATTERSUNDRYFEE && businessData.NEWMATTERSUNDRYFEEGUID) {
              this.SettingForm.controls['AUTOMATICNEWMATTERSUNDRY'].setValue(
                businessData.NEWMATTERSUNDRYFEE + ' - ' + businessData.NEWMATTERSUNDRYFEEGUID,
              );
            } else {
              this.SettingForm.controls['AUTOMATICNEWMATTERSUNDRY'].setValue('');
            }
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.toastr.error(error);
        },
      });
  }

  /**
   * This function is used to change the radio button data value.
   */
  radioChange(value: any): void {
    this.myOutput.emit(value);
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.sub1?.unsubscribe();
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * save the data of business setup
   */
  saveBS() {
    this.isspiner = true;
    let Data = {
      GroupName: 'BusinessSetup',
      GSTTYPE: this.SettingForm.controls.GSTTYPE.value,
      UNITSPERHOUR: this.SettingForm.controls.UNITSPERHOUR.value,
      DELIVERABLES: this.SettingForm.controls.MATTERDELIVERABLEGUID.value,
      DUEDATEOFFSET: this.SettingForm.controls.DUEDATEOFFSET.value,
      VENDORISLIABLEFORSETTLEMENTDATE:
        this.SettingForm.controls.VENDORISLIABLEFORSETTLEMENTDATE.value,
      RATEOVERRIDESEQUENCE: this.SettingForm.controls.RATEOVERRIDESEQUENCE.value,
      DEFAULTEXPENSETYPE: this.SettingForm.controls.DEFAULTEXPENSETYPE.value,
      DEFAULTPAIDTYPE: this.SettingForm.controls.DEFAULTPAIDTYPE.value,
      DEFAULTINCOMETYPE: this.SettingForm.controls.DEFAULTINCOMETYPE.value,
      DEFAULTMATTERCLASS: this.SettingForm.controls.DEFAULTMATTERCLASS.value,
      SHORTNAMESTRATEGY: this.SettingForm.controls.SHORTNAMESTRATEGY.value,
      REQUIRECOSTAGREEMENT: this.SettingForm.controls.REQUIRECOSTAGREEMENT.value,
      OFFICECHEQUEFORMAT: this.SettingForm.controls.OFFICECHEQUEFORMAT.value,
      REQUIREMATTEROWNER: this.SettingForm.controls.REQUIREMATTEROWNER.value,
      REQUIREFEEEARNER: this.SettingForm.controls.REQUIREFEEEARNER.value,
      SUNDRYFEEEARNER: this.SettingForm.controls.SUNDRYFEEEARNER.value,
      REQUIREMATTERTYPE: this.SettingForm.controls.REQUIREMATTERTYPE.value,
      REQUIRECLIENTSOURCE: this.SettingForm.controls.REQUIRECLIENTSOURCE.value,
      REQUIREFIELDOFLAW: this.SettingForm.controls.REQUIREFIELDOFLAW.value,
      CHARGEDISBGSTONGSTFREEMATTERS: this.SettingForm.controls.CHARGEDISBGSTONGSTFREEMATTERS.value,
      REQUIREEXPENSEPAYEE: this.SettingForm.controls.REQUIREEXPENSEPAYEE.value,
      SHOWCONFLICTCHECKFORNEWMATTER: this.SettingForm.controls.SHOWCONFLICTCHECKFORNEWMATTER.value,
      RATEDESCRIPTION1: this.SettingForm.controls.RATEDESCRIPTION1.value,
      RATEDESCRIPTION2: this.SettingForm.controls.RATEDESCRIPTION2.value,
      RATEDESCRIPTION3: this.SettingForm.controls.RATEDESCRIPTION3.value,
      RATEDESCRIPTION4: this.SettingForm.controls.RATEDESCRIPTION4.value,
      RATEDESCRIPTION5: this.SettingForm.controls.RATEDESCRIPTION5.value,
      RATEDESCRIPTION6: this.SettingForm.controls.RATEDESCRIPTION6.value,
      ESTIMATEWARNINGPERCENT: this.SettingForm.controls.ESTIMATEWARNINGPERCENT.value,
      ALLOWESTIMATERANGE: this.SettingForm.controls.ALLOWESTIMATERANGE.value,
      USEHIGHESTIMATEFORWARNING: this.SettingForm.controls.USEHIGHESTIMATEFORWARNING.value,
      ESTIMATENEXTTHRESHOLD: this.SettingForm.controls.ESTIMATENEXTTHRESHOLD.value,
      ESTIMATENEXTWARNINGPERCENT: this.SettingForm.controls.ESTIMATENEXTWARNINGPERCENT.value,
      COUNTRY: this.SettingForm.controls.COUNTRY.value,
      CURRENCYSYMBOL: this.SettingForm.controls.CURRENCYSYMBOL.value,
      TIMEZONE: this.SettingForm.controls.TIMEZONE.value,
      TAXTYPE: this.SettingForm.controls.TAXTYPE.value,
      TAXRATE: this.SettingForm.controls.TAXRATE.value,
      FIRSTTRUSTMONTH: this.SettingForm.controls.FIRSTTRUSTMONTH.value,
      TRUSTSTATE: this.SettingForm.controls.TRUSTSTATE.value,
      DEFAULTTRUSTRECEIPTTYPE: this.SettingForm.controls.DEFAULTTRUSTRECEIPTTYPE.value,
      DEFAULTTRUSTWITHDRAWALTYPE: this.SettingForm.controls.DEFAULTTRUSTWITHDRAWALTYPE.value,
      TRUSTCHEQUEFORMAT: this.SettingForm.controls.TRUSTCHEQUEFORMAT.value,
      TRUSTRECEIPTCOPIES: this.SettingForm.controls.TRUSTRECEIPTCOPIES.value,
      EFTTRUSTACCOUNTNAME: this.SettingForm.controls.EFTTRUSTACCOUNTNAME.value,
      EFTTRUSTBSB: this.SettingForm.controls.EFTTRUSTBSB.value,
      EFTTRUSTACCOUNTNUMBER: this.SettingForm.controls.EFTTRUSTACCOUNTNUMBER.value,
      TRUSTACCACCOUNTNAME: this.SettingForm.controls.TRUSTACCACCOUNTNAME.value,
      TRUSTACCBSB: this.SettingForm.controls.TRUSTACCBSB.value,
      TRUSTACCACCOUNTNUMBER: this.SettingForm.controls.TRUSTACCACCOUNTNUMBER.value,
      PRACACCACCOUNTNAME: this.SettingForm.controls.PRACACCACCOUNTNAME.value,
      PRACACCBSB: this.SettingForm.controls.PRACACCBSB.value,
      PRACACCACCOUNTNUMBER: this.SettingForm.controls.PRACACCACCOUNTNUMBER.value,
      SWIFTID: this.SettingForm.controls.SWIFTID.value,

      TRUSTFIRSTWITHDRAWALCODE: this.SettingForm.controls.TRUSTFIRSTWITHDRAWALCODE.value,
      TRUSTFIRSTWITHDRAWALEFTID: this.SettingForm.controls.TRUSTFIRSTWITHDRAWALEFTID.value,
      TRUSTFIRSTTRANSFERCODE: this.SettingForm.controls.TRUSTFIRSTTRANSFERCODE.value,
      TRUSTFIRSTRECEIPTCODE: this.SettingForm.controls.TRUSTFIRSTRECEIPTCODE.value,
    };
    if (this.currentUser.PRODUCTTYPE == 'Barrister') {
      ((Data['CLERKRATE'] = this.SettingForm.controls.CLERKRATE.value),
        (Data['HOURLYBASERATE'] = this.SettingForm.controls.HOURLYBASERATE.value),
        (Data['DAILYBASERATE'] = this.SettingForm.controls.DAILYBASERATE.value),
        (Data['HOURLYBASERATE2'] = this.SettingForm.controls.HOURLYBASERATE2.value),
        (Data['DAILYBASERATE2'] = this.SettingForm.controls.DAILYBASERATE2.value),
        (Data['HOURLYBASERATE3'] = this.SettingForm.controls.HOURLYBASERATE3.value),
        (Data['DAILYBASERATE3'] = this.SettingForm.controls.DAILYBASERATE3.value),
        (Data['HOURLYBASERATE4'] = this.SettingForm.controls.HOURLYBASERATE4.value),
        (Data['DAILYBASERATE4'] = this.SettingForm.controls.DAILYBASERATE4.value),
        (Data['HOURLYBASERATE5'] = this.SettingForm.controls.HOURLYBASERATE5.value),
        (Data['DAILYBASERATE5'] = this.SettingForm.controls.DAILYBASERATE5.value),
        (Data['HOURLYBASERATE6'] = this.SettingForm.controls.HOURLYBASERATE6.value),
        (Data['DAILYBASERATE6'] = this.SettingForm.controls.DAILYBASERATE6.value));
    }
    let data1 = { Action: 'Update', Data: Data };
    this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.isspiner = false;
            this.behaviorService.DELIVERABLES$.next(
              localStorage.getItem('set_active_DELIVERABLES'),
            );
            localStorage.setItem('clerkrate', JSON.stringify(Data['CLERKRATE']));
            this.currentUser['TAXRATE'] = this.SettingForm.controls.TAXRATE.value;
            this.currentUser['SHOWCONFLICTCHECKFORNEWMATTER'] =
              this.SettingForm.controls.SHOWCONFLICTCHECKFORNEWMATTER.value;
            this.currentUser['CHARGEDISBGSTONGSTFREEMATTERS'] =
              this.SettingForm.controls.CHARGEDISBGSTONGSTFREEMATTERS.value;
            this.currentUser['DEFAULTMATTERCLASS'] =
              this.SettingForm.controls.DEFAULTMATTERCLASS.value;
            localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
            this.toastr.success('Updated successfully');
          } else if (
            (response.CODE == 451 || response.CODE == 450) &&
            response.STATUS == 'warning'
          ) {
            this.isspiner = false;
            this.toastr.warning(response.MESSAGE);
          } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
            this.isspiner = false;
            this.toastr.warning(response.MESSAGE);
          } else {
            this.isspiner = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspiner = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * save the clerk settings when user is barrister
   */
  saveClerk() {
    this.isspinerTE = true;
    let Data = {
      GroupName: 'BusinessSetup',
      SubgroupName: 'Clerk',
      CLERKRATE: this.SettingForm.controls.CLERKRATE.value,
    };
    let data1 = { Action: 'Update', Data: Data };
    this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.isspinerTE = false;
            this.behaviorService.DELIVERABLES$.next(
              localStorage.getItem('set_active_DELIVERABLES'),
            );
            localStorage.setItem('clerkrate', JSON.stringify(Data['CLERKRATE']));
            this.toastr.success('Updated successfully');
          } else if (
            (response.CODE == 451 || response.CODE == 450) &&
            response.STATUS == 'warning'
          ) {
            this.isspinerTE = false;
            this.toastr.warning(response.MESSAGE);
          } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
            this.isspinerTE = false;
            this.toastr.warning(response.MESSAGE);
          } else {
            this.isspinerTE = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspinerTE = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * save the time entries
   */
  saveTimeEntries() {
    this.isspinerTE = true;
    let Data = {
      GroupName: 'BusinessSetup',
      SubgroupName: 'TimeEntries',
      GSTTYPE: this.SettingForm.controls.GSTTYPE.value,
      UNITSPERHOUR: this.SettingForm.controls.UNITSPERHOUR.value,
      DELIVERABLES: this.SettingForm.controls.MATTERDELIVERABLEGUID.value,
      DUEDATEOFFSET: this.SettingForm.controls.DUEDATEOFFSET.value,
      VENDORISLIABLEFORSETTLEMENTDATE:
        this.SettingForm.controls.VENDORISLIABLEFORSETTLEMENTDATE.value,
      RATEOVERRIDESEQUENCE: this.SettingForm.controls.RATEOVERRIDESEQUENCE.value,
    };
    if (this.currentUser.PRODUCTTYPE == 'Barrister') {
      ((Data['HOURLYBASERATE'] = this.SettingForm.controls.HOURLYBASERATE.value),
        (Data['DAILYBASERATE'] = this.SettingForm.controls.DAILYBASERATE.value),
        (Data['HOURLYBASERATE2'] = this.SettingForm.controls.HOURLYBASERATE2.value),
        (Data['DAILYBASERATE2'] = this.SettingForm.controls.DAILYBASERATE2.value),
        (Data['HOURLYBASERATE3'] = this.SettingForm.controls.HOURLYBASERATE3.value),
        (Data['DAILYBASERATE3'] = this.SettingForm.controls.DAILYBASERATE3.value),
        (Data['HOURLYBASERATE4'] = this.SettingForm.controls.HOURLYBASERATE4.value),
        (Data['DAILYBASERATE4'] = this.SettingForm.controls.DAILYBASERATE4.value),
        (Data['HOURLYBASERATE5'] = this.SettingForm.controls.HOURLYBASERATE5.value),
        (Data['DAILYBASERATE5'] = this.SettingForm.controls.DAILYBASERATE5.value),
        (Data['HOURLYBASERATE6'] = this.SettingForm.controls.HOURLYBASERATE6.value),
        (Data['DAILYBASERATE6'] = this.SettingForm.controls.DAILYBASERATE6.value));
    }
    let data1 = { Action: 'Update', Data: Data };
    this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.isspinerTE = false;
            this.behaviorService.DELIVERABLES$.next(
              localStorage.getItem('set_active_DELIVERABLES'),
            );
            this.toastr.success('Updated successfully');
          } else if (
            (response.CODE == 451 || response.CODE == 450) &&
            response.STATUS == 'warning'
          ) {
            this.isspinerTE = false;
            this.toastr.warning(response.MESSAGE);
          } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
            this.isspinerTE = false;
            this.toastr.warning(response.MESSAGE);
          } else {
            this.isspinerTE = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspinerTE = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }

  /**
   * save the rate descriptions
   */
  saveRates() {
    this.isspinerRates = true;
    let Data = {
      GroupName: 'BusinessSetup',
      SubgroupName: 'RateDescriptions',
      RATEDESCRIPTION1: this.SettingForm.controls.RATEDESCRIPTION1.value,
      RATEDESCRIPTION2: this.SettingForm.controls.RATEDESCRIPTION2.value,
      RATEDESCRIPTION3: this.SettingForm.controls.RATEDESCRIPTION3.value,
      RATEDESCRIPTION4: this.SettingForm.controls.RATEDESCRIPTION4.value,
      RATEDESCRIPTION5: this.SettingForm.controls.RATEDESCRIPTION5.value,
      RATEDESCRIPTION6: this.SettingForm.controls.RATEDESCRIPTION6.value,
    };
    let data1 = { Action: 'Update', Data: Data };
    this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.isspinerRates = false;
            this.behaviorService.DELIVERABLES$.next(
              localStorage.getItem('set_active_DELIVERABLES'),
            );
            this.toastr.success('Updated successfully');
          } else if (
            (response.CODE == 451 || response.CODE == 450) &&
            response.STATUS == 'warning'
          ) {
            this.isspinerRates = false;
            this.toastr.warning(response.MESSAGE);
          } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
            this.isspinerRates = false;
            this.toastr.warning(response.MESSAGE);
          } else {
            this.isspinerRates = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspinerRates = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }
}
